import { AlphaVIcon } from './AlphaVIcon';

/**
 * author: GreenTurtwig
 * id 6A261917-D952-4EFD-B8A4-9A91BCF67DE1
 * name alpha-v
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-v.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterVIcon = AlphaVIcon;
export default LetterVIcon